import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const Partnerstva = () => {
  return (
    <Container fluid>
      <Row>
        <Col className="main-header font-weight-bold">Partnerstva</Col>
      </Row>
      <Row>
        <Col className="header-divider">
          <hr />
        </Col>
      </Row>
      <Row>
        <Col>Pregled partnerstev.</Col>
      </Row>
    </Container>
  );
};

export default Partnerstva;
